import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {PiSidebarSimple} from "react-icons/pi";
import {useMenueZustand} from "./MenueZustandContext";

/**
 * Umschalter am Fuß der Seitenleiste (rendert über den offiziellen
 * sidebarControls-Slot des Pakets, siehe GlobalControls.jsx). Eigener
 * Tooltip statt title, aria-pressed für Screenreader; Tastenkürzel "[".
 */
export default function MenueUmschalter() {
    const {eingeklappt, umschalten} = useMenueZustand();

    const beschriftung = eingeklappt ? "Menü ausklappen" : "Menü einklappen";

    const handleKeyDown = (event) => {
        if (event.key !== "Enter" && event.key !== " ") {
            return;
        }

        event.preventDefault();
        umschalten();
    };

    return (
        <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="menue-umschalter-tooltip">{beschriftung} (Taste [)</Tooltip>}
        >
            <span
                role="button"
                tabIndex={0}
                aria-pressed={eingeklappt}
                aria-label={beschriftung}
                className="menue-umschalter"
                onClick={umschalten}
                onKeyDown={handleKeyDown}
            >
                <PiSidebarSimple size="1.35em"/>
                <span className="menue-umschalter-label">{beschriftung}</span>
            </span>
        </OverlayTrigger>
    );
}
